import { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";

function AttendeesModal({
  event,
  attendees,
  onClose,
  loading,
  setSelectedAthlete,
  onViewResults,
  userRole,
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const now = new Date();
  const eventEndDateTime = new Date(`${event.date}T${event.endTimeUTC}`);
  const isPastEvent = eventEndDateTime < now;

  const canViewDetails =
    userRole === "university" ||
    userRole === "highschool" ||
    userRole === "admin";

  const filteredAttendees = attendees.filter((athlete) => {
    const fullName = `${athlete.name} ${athlete.lastname}`.toLowerCase();
    const position = athlete.position?.toLowerCase() || "";
    return (
      fullName.includes(searchTerm.toLowerCase()) ||
      position.includes(searchTerm.toLowerCase())
    );
  });
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg overflow-hidden">
        <div className="flex justify-between items-center px-6 py-4 border-0 border-gray-300">
          <h2 className="text-xl font-semibold text-gray-800">
            Attendees for {event.name}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>
        <div className="px-6 py-3 border-b border-gray-200">
          <input
            type="text"
            placeholder="Search attendees..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="athletes-list p-6 space-y-2 max-h-[60vh] overflow-y-auto">
          {loading ? (
            <div className="flex justify-center items-center h-40">
              <LoadingSpinner />
            </div>
          ) : filteredAttendees.length === 0 ? (
            <p className="text-gray-500">No attendees found.</p>
          ) : (
            filteredAttendees.map((athlete) => (
              <div
                key={athlete.userId}
                className="flex justify-between items-center border border-gray-300 rounded-md px-3 py-2"
              >
                <div className="flex flex-row flex-1">
                  <div className="my-auto rounded-md">
                    <img
                      alt="Athlete Name"
                      src={athlete.profilePicture || "/default-profile-img.png"}
                      className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                      height={40}
                      width={40}
                    />
                  </div>
                  <div className="ml-4">
                    <p className="text-lg uppercase">
                      {athlete.name} {athlete.lastname}
                    </p>
                    <p className="text-sm text-gray-700">{athlete.position}</p>
                  </div>
                </div>

                <div className="flex gap-2">
                  {canViewDetails && (
                    <button
                      onClick={() => setSelectedAthlete(athlete)}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md text-sm"
                    >
                      Profile
                    </button>
                  )}
                  {isPastEvent && canViewDetails && (
                    <button
                      onClick={() => onViewResults(athlete)}
                      className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-md text-sm"
                    >
                      Results
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default AttendeesModal;
